/* eslint-disable react-hooks/exhaustive-deps */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import { useDebounce } from "use-debounce";

const CustomTable = ({
  isLoading,
  headerData,
  Data,
  onClickCreate,
  isAction,
  onSearchData,
  onClickShow,
  onEditData,
  onDeleteData,
  TablePagination,
}) => {
  const location = useLocation();
  const path = location.pathname;
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1000);

  useEffect(() => {
    onSearchData(debouncedSearch);
  }, [debouncedSearch]);

  return (
    <div
      className="overflow-hidden rounded-2xl"
      style={{
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        border: "0.5px solid #fafafa",
        borderRadius: "10px",
      }}
    >
      {/* Search and Button Section */}
      <div className="flex flex-col sm:flex-row justify-between items-center py-5 px-5 w-full  bg-white">
        <input
          id="searchBar"
          name="search"
          type="text"
          value={search}
          placeholder="Cari Data Di Sini"
          onChange={(e) => setSearch(e.target.value)}
          className="h-11 block px-2 w-full sm:w-2/5 md:w-2/5 rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
        />
        {isAction.isAdd ? (
          <button
            className="h-11 flex w-auto sm:w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 mt-4 sm:mt-0 sm:ml-4 self-end sm:self-auto"
            onClick={onClickCreate}
          >
            Tambah Data
          </button>
        ) : null}
      </div>

      {/* Table Section */}
      <TableContainer className=" bg-white" component={Paper}>
        {path === "/dashboard/home" && (
          <h2 className="font-bold ms-4 mt-4">Daftar Pengguna Masuk</h2>
        )}

        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead
            sx={{
              fontFamily: "monospace",
              backgroundColor: "#F5F5F7",
              color: "#4C4E64",
            }}
          >
            <TableRow>
              <TableCell align="center" width="5%" sx={{ fontWeight: "bold" }}>
                No
              </TableCell>
              {headerData.map((header, index) => (
                <TableCell
                  key={index}
                  align={header.align}
                  style={{ width: header.width }}
                  sx={{ fontWeight: "bold" }}
                >
                  {header.label}
                </TableCell>
              ))}
              {isAction &&
              (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Aksi
                </TableCell>
              ) : null}
            </TableRow>
          </TableHead>

          {isLoading ? (
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    height: 100,
                  }}
                  colSpan={headerData.length + 2}
                  align="center"
                >
                  <div className="flex items-center justify-center py-6 gap-3">
                    <div className="scale-57">
                      <FadeLoader height={10} width={5} color="#26a0fc" />
                    </div>
                    <div className="text-sm" style={{ fontFamily: "Poppins" }}>
                      Sedang memuat. . .
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {Data?.length > 0 ? (
                Data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" width="5%">
                      {index + 1}
                    </TableCell>
                    {headerData.map((data, index) => {
                      const rawValue = row[data.key];
                      const displayValue = data.render
                        ? data.render(rawValue)
                        : rawValue;

                      return (
                        <TableCell align={data.align} key={index}>
                          {typeof rawValue === "boolean" ? (
                            <span
                              className={`inline-flex items-center gap-2 px-4 py-1.5 text-sm rounded-2xl font-medium transition-all duration-300 ${
                                rawValue
                                  ? "bg-green-50 text-green-700"
                                  : "bg-red-50 text-red-700"
                              }`}
                            >
                              <span
                                className={`w-2.5 h-2.5 rounded-full ${
                                  rawValue ? "bg-green-500" : "bg-red-500"
                                } shadow-sm`}
                              ></span>
                              {data.label === "Daftar Pencarian Orang"
                                ? rawValue
                                  ? "Ya"
                                  : "Tidak"
                                : rawValue
                                  ? "Aktif"
                                  : "Tidak Aktif"}
                            </span>
                          ) : (
                            displayValue
                          )}
                        </TableCell>
                      );
                    })}

                    {isAction &&
                    (isAction.isShow ||
                      isAction.isEdit ||
                      isAction.isDelete) ? (
                      <TableCell align="center">
                        <div className="flex justify-center gap-2">
                          {isAction.isShow ? (
                            <div>
                              <button
                                className="h-10 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                onClick={() => onClickShow(row)}
                              >
                                <i className="ri-eye-line"></i>
                              </button>
                            </div>
                          ) : null}

                          {isAction.isEdit ? (
                            <div>
                              <button
                                className="h-10 flex w-auto justify-center items-center rounded-xl bg-amber-500 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                onClick={() => onEditData(row)}
                              >
                                <i className="ri-pencil-line"></i>
                              </button>
                            </div>
                          ) : null}

                          {isAction.isDelete ? (
                            <div>
                              <button
                                className="bg-rose-900 h-10 flex w-auto justify-center items-center rounded-xl hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                onClick={() => onDeleteData(row)}
                              >
                                <i className="ri-delete-bin-6-line"></i>
                              </button>
                            </div>
                          ) : null}
                        </div>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    style={{
                      height: 100,
                    }}
                    colSpan={headerData.length + 2}
                    align="center"
                  >
                    <p
                      className="text-sm"
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      Tidak Ada Data
                    </p>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
        {TablePagination}
      </TableContainer>
    </div>
  );
};

export default CustomTable;
